// extracted by mini-css-extract-plugin
export default {"fadeText":"textswitch_fadeText__XFZ7K","visible":"textswitch_visible__uBhIz","hidden":"textswitch_hidden__G7TNR"};